import React from 'react';

import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { getDeviceTypeAndroid } from '../../utils/helper';
import Account from '../../components/AccountInfo/Account/Account';
import Impersonation from '../../components/AccountInfo/Impersonation/Impersonation';
import MyExam from '../../components/AccountInfo/MyExam/MyExam';
import Transanctions from '../../components/AccountInfo/Transactions/Transactions';
import MenuComponent from '../../components/Menu';
import RestrictedContentComponent from '../../components/RestrictedContent';

import { useMoengageEventTracker } from '../../hooks/useMoengage';

import styles from './AccountInfo.module.scss';
import MyProfile from '../../components/AccountInfo/MyProfile/MyProfile';

function MyProfileSettings() {
  const [activeID, setActiveID] = React.useState(1);
  const [isAndroid, setIsAndroid] = React.useState(false);
  const trackMoengageEvent = useMoengageEventTracker();
  const {
    isAuthenticated,
    authUser,
    selectedExamPreference,
  } = useSelector((state) => ({
    isAuthenticated: state.auth.isAuthenticated,
    authUser: state.auth.authUser,
    selectedExamPreference: state?.accountInfo?.userExamPreferenceDetails,
  }));

  React.useEffect(() => {
    if (typeof window !== 'undefined') {
      const { userAgent } = window.navigator;
      setIsAndroid(getDeviceTypeAndroid(userAgent));
    }
  }, []);

  const handleProfile = (event) => {
    event.stopPropagation();
    setActiveID(1);

    trackMoengageEvent('my_profile_tapped', {});
  };

  const handleExam = (event) => {
    event.stopPropagation();
    setActiveID(2);
    trackMoengageEvent('my_exam_tapped', {
      user_exam_selected: selectedExamPreference?.data?.[0]?.name || 'no exam',
      source_screen: 'account_info',
    });
  };

  const handleAccount = (event) => {
    event.stopPropagation();
    setActiveID(3);

    trackMoengageEvent('account_tapped', {
      source_screen: 'account_info',
    });
  };

  const handleTransactions = (event) => {
    event.stopPropagation();
    setActiveID(4);

    trackMoengageEvent('transactions_tapped', {
      source_screen: 'account_info',
    });
  };

  const handleInpersonation = () => {
    setActiveID(5);
  };

  const navLinks = [
    { text: 'My Profile', onClick: handleProfile, id: 1 },
    { text: 'My Exam', onClick: handleExam, id: 2 },
    { text: 'Account', onClick: handleAccount, id: 3 },
    { text: 'Transactions', onClick: handleTransactions, id: 4 },
    ...(authUser?.user_access_status === 1 || authUser?.userAccessStatus === 1
      ? [{ text: 'Impersonate', onClick: handleInpersonation, id: 5 }]
      : []),
  ];

  const components = {
    1: <MyProfile />,
    4: <Transanctions />,
    2: <MyExam />,
    3: <Account />,
    5: <Impersonation />,
  };

  if (isAndroid && isAuthenticated) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.accountInfoMweb}>
          You can find your account information via Web/ App
        </div>
      </div>
    );
  }

  if (!isAuthenticated) return <RestrictedContentComponent />;
  return (
    <div className={styles.wrapper}>
      <aside className={classNames(styles.sidebar)}>
        <MenuComponent items={[]} className={styles.sidebar} />
      </aside>
      <div>
        <div
          className={classNames(styles.moduleWrapper, {
            [styles.profileWrapper]: activeID === 1,
          })}
        >
          <div className={styles.navbarContainer}>
            <div className={styles.navbarWrapper}>
              {navLinks?.map((link) => (
                <div
                  key={link?.id}
                  className={classNames(styles.navLink, {
                    [styles.active]: activeID === link?.id,
                  })}
                  onClick={link?.onClick}
                >
                  {link?.text}
                  <span className={styles.activeTabUnderline} />
                </div>
              ))}
            </div>
          </div>
          <div
            className={classNames(
              styles.containerWrapper,
              { [styles.profileOuterWrapper]: activeID === 1 },
              { [styles.myExamOuterWrapper]: activeID === 2 },
            )}
          >
            {components?.[activeID]}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MyProfileSettings;
